"use strict";

var _classCallCheck = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grabber = void 0;

var Utils_1 = require("../../../../Utils");

var Modes_1 = require("../../../../Enums/Modes");

var Grabber = /*#__PURE__*/function () {
  function Grabber(container) {
    _classCallCheck(this, Grabber);

    this.container = container;
  }

  _createClass(Grabber, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var mouse = container.interactivity.mouse;
      var events = container.options.interactivity.events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      return Utils_1.Utils.isInArray(Modes_1.HoverMode.grab, hoverMode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      var _a, _b;

      var container = this.container;
      var options = container.options;
      var interactivity = options.interactivity;

      if (interactivity.events.onHover.enable && container.interactivity.status === Utils_1.Constants.mouseMoveEvent) {
        var mousePos = container.interactivity.mouse.position;

        if (mousePos === undefined) {
          return;
        }

        var distance = container.retina.grabModeDistance;
        var query = container.particles.quadTree.query(new Utils_1.Circle(mousePos.x, mousePos.y, distance));
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var particle = _step.value;
            var pos = particle.getPosition();

            var _distance = Utils_1.Utils.getDistance(pos, mousePos);

            if (_distance <= container.retina.grabModeDistance) {
              var grabLineOptions = interactivity.modes.grab.links;
              var lineOpacity = grabLineOptions.opacity;
              var grabDistance = container.retina.grabModeDistance;
              var opacityLine = lineOpacity - _distance * lineOpacity / grabDistance;

              if (opacityLine > 0) {
                var optColor = (_a = grabLineOptions.color) !== null && _a !== void 0 ? _a : particle.particlesOptions.links.color;

                if (!container.particles.grabLineColor) {
                  container.particles.grabLineColor = optColor === Utils_1.Constants.randomColorValue || ((_b = optColor) === null || _b === void 0 ? void 0 : _b.value) === Utils_1.Constants.randomColorValue ? Utils_1.Constants.randomColorValue : Utils_1.ColorUtils.colorToRgb(optColor);
                }

                var colorLine = void 0;

                if (container.particles.grabLineColor === Utils_1.Constants.randomColorValue) {
                  colorLine = Utils_1.ColorUtils.getRandomRgbColor();
                } else {
                  colorLine = container.particles.grabLineColor;
                }

                if (colorLine === undefined) {
                  return;
                }

                container.canvas.drawGrabLine(particle, colorLine, opacityLine, mousePos);
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }]);

  return Grabber;
}();

exports.Grabber = Grabber;